import React, { Component } from 'react';
import Loader from 'react-loader-spinner';

class resultPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      "data": {}
    };
  }

  render() {
    return (
    <div 
        style={{
        width: "100%",
        height: "100",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Loader type="ThreeDots" color="#3961f8" height="400" width="100" timeout={18000}/>
    </div>
    );
  }
}

export default resultPage;
